import { useQuery } from "./urqlHooks";

const GET_SII_SALES = `
  query GET_SII_SALES_12_MONTHS($companyIds: [String!]!) {
    get12MonthsNetSalesHolding(companyIds: $companyIds) {
      month
      label
      sales
      companyId
    }
  }
`;

export const GetSII12MonthsSalesHolding = (variables) => {
  const shouldPause = !variables?.companyIds || variables.companyIds.length === 0;
  const [result, reexecuteQuery] = useQuery({
    query: GET_SII_SALES,
    variables,
    pause: shouldPause,
  });

  const { data, fetching, error } = result;
  return { data, fetching, error, reexecuteQuery };
};

const GET_SII_PURCHASES = `
  query GET_SII_PURCHASES_12_MONTHS($companyIds: [String!]!) {
    get12MonthsNetPurchasesHolding(companyIds: $companyIds){
      month
      label
      sales
      companyId
    }
  }
`;

export const GetSII12MonthsPurchasesHolding = (variables) => {
  const shouldPause = !variables?.companyIds || variables.companyIds.length === 0;
  const [result, reexecuteQuery] = useQuery({
    query: GET_SII_PURCHASES,
    variables,
    pause: shouldPause,
  })

  const { data, fetching, error } = result;
  return { data, fetching, error, reexecuteQuery };
}

const GET_DASHBOARD_CARDS = `
  query GET_DASHBOARD_CARDS($companyIds: [String!]!) {
    dashboardCardsHolding(companyIds: $companyIds){
      bankAcountAmount
      bankCreditAmount
      toPay
      toReceive
    }
  }
`;

export const GetDashboardCardsHolding = (variables) => {
  const shouldPause = !variables?.companyIds || variables.companyIds.length === 0;
  const [result, reexecuteQuery] = useQuery({
    query: GET_DASHBOARD_CARDS,
    variables,
    pause: shouldPause,
  })

  const { data, fetching, error } = result;
  return { data, fetching, error, reexecuteQuery };
}

const GET_LAST_SII_SALES = `
  query GET_SII_SALES_LAST_12_MONTHS($companyIds: [String!]!) {
    getLast12MonthsNetSalesHolding(companyIds: $companyIds){
      month
      label
      sales
      companyId
    }
  }
`;

export const GetSIILast12MonthsSalesHolding = (variables) => {
  const shouldPause = !variables?.companyIds || variables.companyIds.length === 0;
  const [result, reexecuteQuery] = useQuery({
    query: GET_LAST_SII_SALES,
    variables,
    pause: shouldPause,
  })

  const { data, fetching, error } = result;
  return { data, fetching, error, reexecuteQuery };
}

const GET_LAST_SII_PURCHASES = `
  query GET_SII_PURCHASES_LAST_12_MONTHS($companyIds: [String!]!) {
    getLast12MonthsNetPurchasesHolding(companyIds: $companyIds){
      month
      label
      sales
      companyId
    }
  }
`;

export const GetSIILast12MonthsPurchasesHolding = (variables) => {
  const shouldPause = !variables?.companyIds || variables.companyIds.length === 0;
  const [result, reexecuteQuery] = useQuery({
    query: GET_LAST_SII_PURCHASES,
    variables,
    pause: shouldPause,
  })

  const { data, fetching, error } = result;
  return { data, fetching, error, reexecuteQuery };
}

const GET_PENDING_PAYMENTS = `
  query GET_PENDING_PAYMENTS($companyIds: [String!]!) {
    findPaymentCollectionHolding(companyIds: $companyIds){
      rut
      name
      outsideProviderId
      valid
      expired30
      expired60
      expired90
      expiredOlder
      documents
      companyId
    }
  }
`;

export const GetPendingPaymentDashboardHolding = (variables) => {
  const shouldPause = !variables?.companyIds || variables.companyIds.length === 0;
  const [result, reexecuteQuery] = useQuery({
    query: GET_PENDING_PAYMENTS,
    variables,
    pause: shouldPause,
  })

  const { data, fetching, error } = result;
  return { data, fetching, error, reexecuteQuery };
}

const GET_PENDING_TO_PAY = `
  query GET_PENDING_TO_PAY($companyIds: [String!]!) {
    findToPayCollectionHolding(companyIds: $companyIds){
      rut
      name
      valid
      expired30
      expired60
      expired90
      expiredOlder
      documents
      companyId
    }
  }
`;

export const GetPendingToPayDashboardHolding = (variables) => {
  const shouldPause = !variables?.companyIds || variables.companyIds.length === 0;
  const [result, reexecuteQuery] = useQuery({
    query: GET_PENDING_TO_PAY,
    variables,
    pause: shouldPause,
  })

  const { data, fetching, error } = result;
  return { data, fetching, error, reexecuteQuery };
}

const BANK_BALANCE_HOLDING = `
query BANK_BALANCE_HOLDING($companyIds: [String!]!){
    allBankBalancesHolding(companyIds: $companyIds) {
      bankId
      availableBalance
      amountApproved
      amountUsed
      creditLineAvailable
      currencyType
      accountNumber
      createdAt
      accountType
      isActive
      includeInCashFlow
      passwordId
      companyId
    }
  }
`;

export const GetBankBalanceDataHolding =(variables) => {
  const shouldPause = !variables?.companyIds || variables.companyIds.length === 0;
  const [result, reexecuteQuery] = useQuery({
    query: BANK_BALANCE_HOLDING,
    variables,
    pause: shouldPause,
  });
  const { data, fetching, error } = result;
  return { data, fetching, error, reexecuteQuery };
};

const GET_COMPANIES = `
query GET_COMPANIES($ids: [String!]!){
    findCompaniesByIds(ids: $ids){
        id,
        name,
        rut,
        clientPaymentDays,
        providerPaymentDays,
        alias,
        plan,
        reports{
            name,
            url
        }
  }
}
`;

export const GetCompaniesData = (variables) => {
  const [result, reexecuteQuery] = useQuery({
    query: GET_COMPANIES,
    variables,
  });
  const { data, fetching, error } = result;
  return { data, fetching, error, reexecuteQuery };
};
